import { render, staticRenderFns } from "./CompareLoans.vue?vue&type=template&id=25011e98&scoped=true&"
import script from "./CompareLoans.vue?vue&type=script&lang=js&"
export * from "./CompareLoans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25011e98",
  null
  
)

export default component.exports